import { Avatar, AvatarProps } from '@chakra-ui/react';

type Props = {
  name: string;
} & Omit<AvatarProps, 'bg' | 'color'>;

export function Initials({ name, ...rest }: Props): JSX.Element {
  return (
    <Avatar
      name={name}
      bg="palette_blue.5"
      color={'palette_blue.100'}
      {...rest}
    ></Avatar>
  );
}
